import {
  DataFetcher,
  PriorityConfig,
  useGrpcRequest,
} from '@aboutyou/data-fetcher';
import {CategoryMetaService_GetBreadcrumbsLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/category_page/v1/meta/service.grpc.lazy';
import React, {FC} from 'react';
import {BreadcrumbsView} from '../../../features/Breadcrumbs/Breadcrumbs';
import {useAnyFilterFlyoutOpened} from '../../../features/Filters/shared/useAnyFilterFlyoutOpened';
import {useAppliedPotentialFilters} from '../../../features/ProductStream/utils';
import {useCategoryCacheKeyTransformer, useCategoryIdentifier} from '../utils';
import {CategoryBreadcrumbsLoading} from './CategoryBreadcrumbsLoading';

export const CategoryBreadcrumbs: FC<PriorityConfig> = ({
  renderingPriority,
}) => {
  return (
    <DataFetcher
      request={useBreadcrumbs()}
      Error={null}
      View={BreadcrumbsView}
      Loading={CategoryBreadcrumbsLoading}
      renderingPriority={renderingPriority}
    />
  );
};

const useBreadcrumbs = () => {
  const categoryIdentifier = useCategoryIdentifier();
  const categoryCacheKeyTransformer = useCategoryCacheKeyTransformer();
  const appliedFilters = useAppliedPotentialFilters();
  const isFilterFlyoutOpen = useAnyFilterFlyoutOpened();

  return useGrpcRequest(
    CategoryMetaService_GetBreadcrumbsLazy,
    {
      category: {
        identifier: categoryIdentifier,
      },
      appliedFilters: {
        filters: appliedFilters,
        quickFilter: {},
      },
    },
    {
      disabled: isFilterFlyoutOpen,
      retry: false,
      transformCacheKey: categoryCacheKeyTransformer,
      nonEssential: true,
    },
  );
};
